import useParamsLocale from '#/data/useParamsLocale';
import { cn } from '#/lib/utils';
import { format, formatDistanceToNowStrict } from 'date-fns';
import { ComponentProps } from 'react';
import { create } from 'zustand';

type TimestampStore = {
  pressed: boolean;
  toggle: () => void;
};

const useTimestampStore = create<TimestampStore>()(set => ({
  pressed: false,
  toggle: () => set(state => ({ pressed: !state.pressed })),
}));

interface Props extends ComponentProps<'span'> {
  date?: number | Date | null;
  toggleable?: boolean;
}

export function Timestamp({ date, className, toggleable, ...props }: Props) {
  const locale = useParamsLocale();
  const pressed = useTimestampStore(state => state.pressed);
  const toggle = useTimestampStore(state => state.toggle);
  return date != null ? (
    <span
      onClick={toggleable ? toggle : undefined}
      className={cn(
        {
          'cursor-pointer': toggleable,
        },
        className
      )}
      {...props}
    >
      {!toggleable || !pressed
        ? format(date, 'PP HH:mm:ss', { locale })
        : formatDistanceToNowStrict(date, { locale, addSuffix: true })}
    </span>
  ) : (
    <>-</>
  );
}
